"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { Search, List, X, Sparkles, ArrowUp } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
export default function QuickNavDrawer(t0) {
  const $ = _c(20);
  const {
    sections: t1
  } = t0;
  const sections = t1 === undefined ? [] : t1;
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showScrollTop, setShowScrollTop] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleScroll = () => {
        setShowScrollTop(window.scrollY > 600);
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[2] !== isOpen) {
    t4 = () => {
      if (isOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      return _temp;
    };
    t5 = [isOpen];
    $[2] = isOpen;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] !== searchQuery) {
    t6 = sec => {
      const query = searchQuery.toLowerCase().trim();
      if (!query) {
        return true;
      }
      const numStr = String(sec.id);
      const numPadded = String(sec.id).padStart(2, "0");
      return sec.title.toLowerCase().includes(query) || numStr === query || numPadded === query;
    };
    $[5] = searchQuery;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const filteredSections = sections.filter(t6);
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = id => {
      setIsOpen(false);
      const element = document.getElementById(`section-${id}`);
      if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset + -90;
        window.scrollTo({
          top: y,
          behavior: "smooth"
        });
      }
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const scrollToSection = t7;
  const scrollToTop = _temp2;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsOpen(true);
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <button onClick={t8} className="flex items-center gap-2 px-3 py-2.5 sm:px-4 sm:py-3 rounded-full bg-[#0F1C2E] text-[#F4EFE6] border border-[#C9A84C]/40 shadow-[0_10px_30px_rgba(15,28,46,0.35)] hover:bg-[#1A2B42] hover:border-[#DF6D2A] transition-all active:scale-95"><List size={16} className="text-[#DF6D2A] sm:w-[18px] sm:h-[18px]" /><span className="font-body text-[12px] sm:text-[13px] font-medium tracking-wide hidden sm:inline">Jump to Section (1-60)</span><span className="font-body text-[12px] font-medium tracking-wide sm:hidden">Sections</span></button>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== showScrollTop) {
    t10 = showScrollTop && <motion.button initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.8
    }} onClick={scrollToTop} aria-label="Scroll to top" className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-[#DF6D2A] text-white flex items-center justify-center shadow-lg hover:bg-[#c05a3f] transition-all active:scale-95"><ArrowUp size={16} strokeWidth={2} className="sm:w-[18px] sm:h-[18px]" /></motion.button>;
    $[10] = showScrollTop;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10) {
    t11 = <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-[900] flex items-center gap-2 sm:gap-3">{t9}<AnimatePresence>{t10}</AnimatePresence></div>;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const T0 = AnimatePresence;
  const t12 = isOpen && <><motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onClick={() => setIsOpen(false)} className="fixed inset-0 z-[1500] bg-[#0F1C2E]/60 backdrop-blur-sm" /><motion.div initial={{
      opacity: 0,
      y: 40,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 40,
      scale: 0.95
    }} transition={{
      duration: 0.25,
      ease: [0.32, 0.72, 0, 1]
    }} className="fixed bottom-0 left-0 right-0 sm:bottom-6 sm:left-6 sm:right-6 sm:max-w-[540px] sm:ml-auto z-[1501] bg-[#F4EFE6] sm:border sm:border-[#0F1C2E]/20 sm:rounded-2xl rounded-t-2xl shadow-[0_-10px_40px_rgba(0,0,0,0.2)] sm:shadow-[0_25px_60px_rgba(0,0,0,0.3)] overflow-hidden flex flex-col max-h-[85vh] sm:max-h-[80vh]"><div className="flex items-center justify-between p-4 sm:p-5 border-b border-[#0F1C2E]/10 bg-[#0F1C2E] text-[#F4EFE6]"><div className="flex items-center gap-2"><Sparkles size={16} className="text-[#C9A84C] sm:w-[18px] sm:h-[18px]" /><h3 className="font-display text-[17px] sm:text-[20px] font-semibold tracking-wide">Girmitiya Proud Index</h3></div><button onClick={() => setIsOpen(false)} className="w-8 h-8 rounded-full flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 transition-colors"><X size={18} /></button></div><div className="p-3 sm:p-4 border-b border-[#0F1C2E]/10 bg-[#EAE4D8]/50"><div className="relative"><Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#4C596B]" /><input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search by title or number..." className="w-full pl-9 pr-14 py-2.5 rounded-xl bg-white border border-[#0F1C2E]/15 text-[14px] text-[#0F1C2E] placeholder-[#4C596B]/60 focus:outline-none focus:border-[#DF6D2A] font-body" autoFocus={true} />{searchQuery && <button onClick={() => setSearchQuery("")} className="absolute right-3 top-1/2 -translate-y-1/2 text-[12px] text-[#4C596B] hover:text-[#0F1C2E] font-body">Clear</button>}</div></div><div className="flex-1 overflow-y-auto p-2.5 sm:p-3 divide-y divide-[#0F1C2E]/5 overscroll-contain">{filteredSections.length > 0 ? filteredSections.map(sec_0 => <button key={sec_0.id} onClick={() => scrollToSection(sec_0.id)} className="w-full flex items-center justify-between p-2.5 sm:p-3 rounded-lg text-left hover:bg-[#DF6D2A]/10 active:bg-[#DF6D2A]/15 transition-colors group"><div className="flex items-center gap-2.5 min-w-0"><span className="font-mono text-[11px] sm:text-[12px] font-bold text-[#DF6D2A] bg-[#DF6D2A]/10 px-1.5 py-0.5 sm:px-2 sm:py-1 rounded flex-shrink-0">{String(sec_0.id).padStart(2, "0")}</span><span className="font-display text-[13.5px] sm:text-[15px] text-[#0F1C2E] font-medium group-hover:text-[#DF6D2A] transition-colors truncate">{sec_0.title}</span></div><span className="font-body text-[10px] sm:text-[11px] text-[#4C596B] opacity-60 ml-2 flex-shrink-0">{sec_0.images.length > 0 ? `${sec_0.images.length} imgs` : "Record"}</span></button>) : <div className="p-6 sm:p-8 text-center text-[#4C596B] font-body text-[13px] sm:text-[14px]">No matching section found for “{searchQuery}”</div>}</div><div className="px-4 py-2.5 sm:px-5 sm:py-3 border-t border-[#0F1C2E]/10 bg-[#EAE4D8] text-center font-body text-[11px] sm:text-[12px] text-[#4C596B]">Showing {filteredSections.length} of {sections.length} chapters</div></motion.div></>;
  let t13;
  if ($[14] !== T0 || $[15] !== t12) {
    t13 = <T0>{t12}</T0>;
    $[14] = T0;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t11 || $[18] !== t13) {
    t14 = <>{t11}{t13}</>;
    $[17] = t11;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  return t14;
}
function _temp2() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
function _temp() {
  document.body.style.overflow = "";
}